import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form, FormGroup, Input, Label, Row, Col, FormText } from 'reactstrap';
import axios from 'axios';
import StorageService from '../../services/StorageService';
import Recaptcha from 'react-google-invisible-recaptcha';
import AppleSignin from 'react-apple-signin-auth';
import { GoogleLogin } from '@react-oauth/google';
import AppleSignInButton from '../../components/AppleSignInButton';
import GoogleSignInButton from '../../components/GoogleSignInButton';
import { auth } from 'services/api';

const style2={
    textDecoration: 'underline',
    color: '#00adad',
    cursor: 'pointer'
  };

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            company: '',
            companyName: '',
            password: '',
            success: false,
            authState: 'LOGIN',
            name: '',
            contact: '',
            privacyModal: false,
            loginByPin: false,
            pin: '',
            setpassword: '',
            remember: false,
            store: '',
            requested: false,
            user: []
        };
    }

    responseMessage = (response) => {
        if(response && Object.keys(response).length != 0) {
          this.googleLogin(response.credential);
        } else {
          alert('Error login. Please try again');
        }
    };

    errorMessage = (error) => {
      alert(error);
      console.log(error);
    };

    toggle = () => () => {
        return this.setState({
        privacyModal: !this.state.privacyModal
        });
    };

    changeHandler = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    changeAuthState = state => event => {
        this.setState({
            authState: state
        })
    };

    goto = () => {
        this.props.history.push({
            pathname: '/forgot-password',
        });
    };

    handleSubmit = event => {
        event.preventDefault();
        this.recaptcha.execute();
    };

    onResolved = async () => {
        const token = this.recaptcha.getResponse();
        this.recaptcha.reset();
        this.validateHuman(token);
    };

    validateHuman = token => {
        const url = process.env.REACT_APP_API_URL;
        const formData = {
            token: token,
        };

        axios
        .post(url + ':3000/v1/ecart/verifyCaptcha', formData)
        .then(response => {
            const result = response.data;
            if (result.error == true && result.message != 'Success') {
            return false;
            }
            if (result.data) {
            if (result.data.success) {
                if(this.state.loginByPin) {
                this.loginPin();
                } else {
                this.login();
                }
            }
            }
        })
        .catch(error => {
            alert(error);
            return false;
        });
    };

    requestPin = () => {
        const { company, email, store } = this.state;
        auth.forgotPassword(store, email, company)
        .then(data => {
        if(data) this.setState({ requested: !this.state.requested, pin: '' });
        });
    };

    appleLogin = (res) => {
        const { company } = this.state;
        const url = process.env.REACT_APP_UNITY_API2_URL;
        let key = StorageService.getSession('session_key');
        let token = res.authorization.id_token;
        let user = null;

        if(res.user) user = res.user;
        const formData = {
            session_key: key,
            company_id: company,
            user: user,
            id_token: token
        };
        axios
        .post(url + ':3030/v1/cart/customer/login/appleid', formData)
        .then(response => {
            const result = response.data;
            if (result.error == true && result.message != 'Success') {
            alert(result.message);
            return;
            }

            if (result.data) {
            result.data.company = this.props.match.params.company;
            StorageService.setSession('consumer', result.data);
            window.location.reload();
            } else {
            alert('Login Failed. Please try again later.');
            }
        })
        .catch(error => {
            alert('Login Failed. Please try again later.');
        });
    };

  googleLogin = (token) => {
    const { company } = this.state;
    const url = process.env.REACT_APP_UNITY_API2_URL;
    let key = StorageService.getSession('session_key');
    const formData = {
      session_key: process.env.REACT_APP_API_KEY,
      company_id: company,
      id_token: token
    };
    axios
      .post(url + ':3030/v1/cart/customer/login/googleid', formData)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }

        if (result.data) {
          result.data.company = this.props.match.params.company;
          StorageService.setSession('consumer', result.data);
          window.location.reload();
        } else {
          alert('Login Failed. Please try again later.');
        }
      })
      .catch(error => {
        alert('Login Failed. Please try again later.');
      });
  };

    loginPin = () => {
        const { setpassword, company, email, pin } = this.state;
        const url = process.env.REACT_APP_UNITY_API2_URL;
        let key = StorageService.getSession('session_key');
        const formData = {
        session_key: key,
        user_password: setpassword,
        email: email,
        company_id: company,
        user_pin: pin
        };

        axios
        .post(url + ':3030/v2/cart/customer/password/update', formData)
        .then(response => {
            const result = response.data;
            if (result.error == true && result.message != 'Success') {
            alert(result.message);
            return;
            }

            if (result.data) {
            result.data.company = this.props.match.params.company;
            StorageService.setSession('consumer', result.data);
            window.location.reload();
            } else {
            alert('Login Failed. Please try again later.');
            }
        })
        .catch(error => {
            alert('Login Failed. You have entered an invalid username or password. Please try again.');
        });
    };

    login = () => {
        const { password, company, email } = this.state;
        const url = process.env.REACT_APP_UNITY_API2_URL;
        let key = StorageService.getSession('session_key');
        const formData = {
            session_key: key,
            user_password: password,
            email: email,
            company_id: company,
        };

        axios
        .post(url + ':3030/v1/cart/customer/login', formData)
        .then(response => {
            const result = response.data;
            if (result.error == true && result.message != 'Success') {
            alert(result.message);
            return;
            }

            if (result.data) {
            result.data.company = this.props.match.params.company;
            StorageService.setSession('consumer', result.data);
            window.location.reload();
            } else {
            alert('Login Failed. Please try again later.');
            }
        })
        .catch(error => {
            alert('Login Failed. You have entered an invalid username or password. Please try again.');
        });
    };

    componentDidMount() {
        if (this.props.company && this.props.store) {
            this.setState({
                company: this.props.company.CompanyID,
                store: this.props.store.store_code
            });
        }

        if(localStorage.getItem('myemail')) {
            this.setState({
                email: localStorage.getItem('myemail')
            });
        }
    }

  render() {
    const {
      usernameLabel,
      usernameInputProps,
      passwordLabel,
      passwordInputProps,
    } = this.props;

    const {authState, loginByPin, requested} = this.state;

    return (
      <Form onSubmit={this.handleSubmit} className="ps-form mb-3">
        <Row>
            <Col md={6} className="ps-auth-login">
              
            {!loginByPin && 
                <div>
                    <FormGroup>
                      <Label for={usernameLabel}>{usernameLabel}</Label>
                      <Input
                        {...usernameInputProps}
                        name="email"
                        value={this.state.email}
                        onChange={this.changeHandler}
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                        <Label for={passwordLabel}>{passwordLabel}</Label>
                        <Input
                        {...passwordInputProps}
                        name="password"
                        value={this.state.password}
                        onChange={this.changeHandler}
                        required={authState === 'LOGIN' ? true : false}
                        />
                    </FormGroup>
                    <FormGroup check>
                    <span>
                        <Input 
                        type="checkbox" 
                        name="remember"              
                        checked={this.state.remember}
                        onChange={event => { 
                          if(event.target.checked)  { localStorage.setItem('myemail', this.state.email);}
                          this.setState({ remember: event.target.checked })
                        }
                        } />{' '}
                        Remember my email
                    </span>
                    </FormGroup> <br/>
                    <Button size="lg" color="primary" className="border-0 mr-3" type="submit">Login</Button>
                    <span style={style2} onClick={() => this.setState({loginByPin: !this.state.loginByPin})}>Login by PIN</span>
                </div>
            }

            {loginByPin && 
                <div>
                    <Label for={usernameLabel}>{usernameLabel}</Label>
                    <FormGroup row className="mb-0">
                      <Col sm={9}>
                        <Input {...usernameInputProps} name="email" value={this.state.email} onChange={this.changeHandler} required/>
                      </Col>
                      <Col sm={3}>
                        <Button color="primary" disabled={requested} className="border-0" type="button" onClick={() => this.requestPin()}>Send PIN</Button>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col sm={6}>
                        <Label for="pin">PIN</Label>
                        <Input type="text" name="pin" value={this.state.pin} onChange={this.changeHandler} required/>
                        {requested && <FormText>Requested. A pin will be sent to your email address. Please use the PIN in that message to login.</FormText>}
                      </Col>
                      <Col sm={6}>
                        <Label className="d-flex" for="setpassword">Set Password&nbsp;<FormText>(Optional)</FormText></Label>
                        <Input type="password" name="setpassword" value={this.state.setpassword} onChange={this.changeHandler}/>
                        <FormText>Set a password to login using your email and password next time</FormText>
                      </Col>
                    </FormGroup>                  
                    <FormGroup check>
                        <span>
                            <Input 
                            type="checkbox" 
                            name="remember"              
                            checked={this.state.remember}
                            onChange={event => { 
                              if(event.target.checked)  { localStorage.setItem('myemail', this.state.email);}
                              this.setState({ remember: event.target.checked })
                            }
                            } />{' '}
                            Remember my email
                        </span>
                    </FormGroup> <br/>
                    <Button size="lg" color="primary" className="border-0 mr-3" type="submit">Login</Button>
                    <span style={style2} onClick={() => this.setState({loginByPin: !this.state.loginByPin, password: ''})}>Login by Password</span>
                </div>
            }
            
            
 
            </Col>
            <Col md={6} className="ps-auth-register">
              <div className="or-divider">
                <span>OR</span>
              </div>
              <div className="login-or-divider noline"><span>Connect with:</span></div><br/>
              <div className="d-md-flex justify-content-md-center">
                <div className="mx-2">
                  <AppleSignin
                      authOptions={{
                        clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                        scope: 'email name',
                        redirectURI: process.env.REACT_APP_APPLE_REDIRECTURI,
                        nonce: process.env.REACT_APP_APPLE_NONCE,
                        state: '',
                        usePopup: true
                      }}
                      onSuccess={(response) => this.appleLogin(response)}
                      onError={(error) => {console.log(error.error); }}
                      skipScript={false}
                      render={(props) => <AppleSignInButton {...props} />}
                    />
                </div>
                <div className="mx-2">
                  <GoogleLogin onSuccess={this.responseMessage} onError={this.errorMessage} />
                </div>
              </div>
            
            <br/>
            <small className="text-muted">Please note that New Sign-In by Apple ID that hide email will create a new account as Apple generates a proxy email address
        . To track your orders login using the same email address.</small>
            </Col>
          </Row>
        <Recaptcha
          ref={ref => (this.recaptcha = ref)}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE}
          onResolved={this.onResolved}
          badge="bottomleft"
        />
      </Form>
    );
  }
}

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

LoginForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};

LoginForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
  },

  onLogoClick: () => {},
};

export default LoginForm;
